const cardTokens = ({ radii }) => ({
  sizesRadii: {
    small: radii.small,
    full: radii.regular,
  },
});

export default cardTokens;
